import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { MembershipCard } from './components/';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetMembershipPackages, actionResetMembershipPackage } from 'actions';
import { makeStyles } from '@material-ui/styles';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionResetPaymentTransaction } from 'actions';
import { genfunction } from 'helpers';

const { MembershipPackagesDisplayAreaNo, PurchaseMembershipNotAllowedForOrganizationBooking } = window['runConfig'];


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    pagination: {
        marginTop: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    }
}));


const MembershipList = (props) => {
    const classes = useStyles();

    const dispatch = useDispatch();
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const reducerMembershipPackages = useSelector(state => state.reducerMembershipPackages);
    const events = useSelector(state => state.reducerShopCart.events);
    const paymenttranstate = useSelector(state => state.reducerPaymentTransaction.Payment);
    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const [colorState, setColorState] = React.useState('');
    const [error, seterror] = useState("");

    useEffect(() => {
        if (events && events.length == 0 && membershipPackages && membershipPackages.length == 0 && gaTickets && gaTickets.length == 0 &&
            giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0 && paymenttranstate.hasOwnProperty("ReceiptNo") && paymenttranstate.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);

    useEffect(() => {
        if (membershipPackages && membershipPackages.length < 1 && reducerMembershipPackages && reducerMembershipPackages.membershipPackage && reducerMembershipPackages.membershipPackage.hasOwnProperty('MembershipPackageID')) {
            actionResetMembershipPackage(dispatch);
        }
    }, []);

    useEffect(() => {
        if (reducerMembershipPackages && reducerMembershipPackages.membershippackagesError && reducerMembershipPackages.membershippackagesError.length > 0) {
            seterror(reducerMembershipPackages.membershippackagesError);
        }
    }, [reducerMembershipPackages.membershippackagesError]);

    useEffect(() => {

        if (reducerMembershipPackages.loading == true) {
            actionStartAppLoader(dispatch);
        }
        else {
            actionEndAppLoader(dispatch);
        }

    })

    useEffect(() => {
        actionGetMembershipPackages(dispatch, MembershipPackagesDisplayAreaNo);
    }, []);

    const errorcancelhandle = () => {
        seterror('');
    }

    const Joinredirect = (membership) => {

        if (membershipPackages && membershipPackages.length > 0 && membershipPackages.filter(x => x.MembershipPackageID == membership.MembershipPackageID).length == 0) {
            seterror('You already have one membership package in your cart!');
        }
        else if (genfunction.IsOrganization(events)) {
            setColorState('info');
            seterror(PurchaseMembershipNotAllowedForOrganizationBooking);
        }
        else {
            props.history.push({
                pathname: '/memberships/join/' + membership.MembershipPackageID
            })
        }
    }

    const RenewRedirect = (membership) => {
        
        if (genfunction.IsOrganization(events)) {
            setColorState('info');
            seterror(PurchaseMembershipNotAllowedForOrganizationBooking);
        }
        else {
            props.history.push({
                pathname: '/memberships/membervalidate/' + membership.MembershipPackageID
            })
        }
    }

    return (

        <div className={classes.root}>
            <ErrorHandling color={colorState} msg={error.length > 0 ? error : ''}
                open={error.length > 0 ? true : false} handleclose={errorcancelhandle} />
            <div className={classes.content}>
                <Grid container
                    spacing={2}
                    style={{ paddingTop: window.matchMedia("(max-width: 500px)").matches ? 35 : 5 }}
                >

                    {reducerMembershipPackages.membershippackages.map((membership, i) => {
                        return membership !== undefined ?
                            <Grid
                                item
                                key={membership.MembershipPackageID}
                                lg={4}
                                md={6}
                                xs={12}
                            >
                                <MembershipCard membership={membership} JoinMemberships={Joinredirect} RenewMembership={RenewRedirect} />
                            </Grid>

                            : null
                    })}
                </Grid>
            </div>
        </div>
    );
};

export default MembershipList;
